import { Component, Vue, PropSync } from 'vue-property-decorator';

@Component
export default class HeaderLogoComponent extends Vue {
    public demoVar: boolean = true;
    @PropSync('showWhite', { type: Boolean }) public syncedShowWhite!: boolean;


    // tslint:disable-next-line: no-empty
    public mounted() {

    }

    public getTextColor(useWhite: boolean): string {
        return useWhite ? 'color-white' : 'color-gray';
    }
}
